import React, { Fragment } from 'react';
const navItems = [{
  label: 'NEWS',
  bold: false
}, {
  label: 'BRANDS',
  bold: false
}, {
  label: 'AGENCIES',
  bold: false
}, {
  label: 'FOCUS',
  bold: false
}, {
  label: 'EDITIONS',
  bold: false
}, {
  label: 'RANKING',
  bold: false
}, {
  label: 'CONTACT',
  bold: true
}];
const socialIcons = [{
  src: 'https://cdn.magicpatterns.com/patterns/figma-svgs/TmuSK63UZRrBCoTmT1iulP/1166-116.svg',
  alt: 'LinkedIn',
  w: 83,
  h: 77
}, {
  src: 'https://cdn.magicpatterns.com/patterns/figma-svgs/TmuSK63UZRrBCoTmT1iulP/1166-138.svg',
  alt: 'Instagram',
  w: 83,
  h: 83
}, {
  src: 'https://cdn.magicpatterns.com/patterns/figma-svgs/TmuSK63UZRrBCoTmT1iulP/1166-160.svg',
  alt: 'X/Twitter',
  w: 80,
  h: 80
}, {
  src: 'https://cdn.magicpatterns.com/patterns/figma-svgs/TmuSK63UZRrBCoTmT1iulP/1166-87.svg',
  alt: 'Communicate',
  w: 107,
  h: 77
}, {
  src: 'https://cdn.magicpatterns.com/patterns/figma-svgs/TmuSK63UZRrBCoTmT1iulP/1166-103.svg',
  alt: 'Facebook',
  w: 77,
  h: 77
}];
export function Footer() {
  return <footer className="site-footer mt-6" data-id="element-15">
      <div className="site-footer-inner" style={{
      minHeight: '200px'
    }} data-id="element-16">
        {/* Nav Links */}
        <nav className="flex flex-wrap justify-center items-center pt-5 lg:pt-6 pb-6 lg:pb-8" data-id="element-17">
          {navItems.map((item, index, array) => <Fragment key={item.label} data-id="element-18">
              <a href={`#${item.label.toLowerCase()}`} className={`text-white text-footer-nav text-upper hover:opacity-70 transition-opacity ${item.bold ? 'font-bold' : 'font-normal'}`} style={{
            letterSpacing: '0.14em'
          }} data-id="element-19">
                {item.label}
              </a>
              {index < array.length - 1 && <span className="text-white text-footer-nav mx-2 lg:mx-3" style={{
            letterSpacing: '0.14em'
          }} data-id="element-20">
                  I
                </span>}
            </Fragment>)}
        </nav>

        {/* Social Icons */}
        <div className="flex items-center justify-center gap-5 lg:gap-8 pb-6 lg:pb-8" data-id="element-21">
          {socialIcons.map(icon => <a key={icon.alt} href="#" className="hover:opacity-70 transition-opacity" data-id="element-22">
              <img src={icon.src} alt={icon.alt} className="w-[40px] h-[40px] md:w-[50px] md:h-[50px] lg:w-[55px] lg:h-[55px] object-contain" data-id="element-23" />
            </a>)}
        </div>

        {/* Copyright */}
        <p className="text-white text-footer-copy text-center pb-5 lg:pb-6" style={{
        letterSpacing: '0.14em'
      }} data-id="element-24">
          ®Communicate – All Rights reserved 2026 – Special Edition FZ
        </p>
      </div>
    </footer>;
}